module.exports = __webpack_public_path__ + "static/media/icon_8.fcf87951.svg";